// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gK","advertCardNum":"c-a_gL"};